import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { jobs, departments, testimonies, user, navigation } from "./modules";

const store = new Vuex.Store({
	modules: {
		jobs,
		departments,
		testimonies,
		user,
		navigation
	}
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js